type KycDefaultData = { kyc_level: string | null };

export interface ReferralInfo {
  referral_code: string | null;
  referral_type: string | null;
}

export const SessionEvent = {
  SignUpClick: 'sign_up_click',
  SsoSignUpClick: 'sso_sign_up_click',
  SignUpComplete: 'sign_up_complete',
  SsoSignUpComplete: 'sso_sign_up_complete',
  LogInEmailClick: 'log_in_email_click',
  WelcomeGoToButton: 'welcome_goto_button',
  Alternative2faMethodClick: 'alternative_2fa_method_click',
  Enable2faWithOtpClick: 'enable_2fa_with_otp_click',
  Enable2faWithAlternativesClick: 'enable_2fa_with_alternatives_click',
  // 2024.07.12 update
  GetStartedClick: 'get_started_click',

  CreateAccountPageView: 'create_account_page_view',
  LoginPageView: 'login_page_view',

  GnbLoginClick: 'gnb_login_click',
  GnbHamburgerClick: 'gnb_hamburger_click',
  GnbHamburgerLoginClick: 'gnb_hamburger_login_click',
} as const;

export interface SessionDataType {
  [SessionEvent.WelcomeGoToButton]: KycDefaultData;
  [SessionEvent.SignUpClick]: ReferralInfo & {
    fbc?: string;
  };
  [SessionEvent.SsoSignUpClick]: {
    referral_code: string | null;
    auth_type: 'email' | 'google' | 'apple';
    fbc?: string;
  };
  [SessionEvent.SignUpComplete]: { user_id: string };
  [SessionEvent.SsoSignUpComplete]: { user_id: string };
  [SessionEvent.GetStartedClick]: { start_type: 'Login' | 'Signup'; button_location: 'GNB' | 'MIDDLE' };

  [SessionEvent.CreateAccountPageView]: {
    type: 'social' | 'email' | 'root';
  };
  [SessionEvent.LoginPageView]: {};
  [SessionEvent.GnbLoginClick]: { button_text: 'Login' | 'Sign up' };
  [SessionEvent.GnbHamburgerClick]: {};
  [SessionEvent.GnbHamburgerLoginClick]: { button_text: 'Login' | 'Sign up' };
}

export const KycEvent = {
  VerifyGoToButton: 'verify_goto_button',
  VerifyCancelButton: 'verify_cancel_button',
  VerificationGoToButton: 'verification_goto_button',
  KycPopUpView: 'kyc_pop_up_view',
  KycPopUpClick: 'kyc_pop_up_click',
  IdentityVerificationClick: 'identity_verification_click',
  KycVerificationOpenClick: 'kyc_verification_open_click', // renamed from verification_open_button
  KycVerificationBannerClick: 'kyc_verification_banner_click',
  // kyc modal view
  KycPageView: 'kyc_page_view',
  KycProgressEvent: 'kyc_progress_event',

  // kyc page view
  IdentityVerificationView: 'identity_verification_view',
  // kyc simple verification
  IdentityVerificationSimpleVerificationClick: 'identity_verification_simple_verification_click',
  KycSimplifiedModalView: 'kyc_simplified_modal_view',
  KycSimplifiedModalClickVerify: 'kyc_simplified_modal_click_verify',
} as const;

export interface KycDataType {
  [KycEvent.VerifyGoToButton]: KycDefaultData;
  [KycEvent.VerifyCancelButton]: KycDefaultData;
  [KycEvent.VerificationGoToButton]: KycDefaultData;
  [KycEvent.KycPopUpView]: { kyc_review_type: string | null };
  [KycEvent.KycPopUpClick]: { kyc_review_type: string | null };
  [KycEvent.IdentityVerificationClick]: { grace_period_flag: boolean };
  [KycEvent.KycVerificationOpenClick]: KycDefaultData;
  [KycEvent.KycVerificationBannerClick]: { kyc_level: number; link_text: string; banner_text: string };
  [KycEvent.KycProgressEvent]: { message_txt: string; kyc_payload: object };
  [KycEvent.IdentityVerificationView]: { simple_verification_status: string | null };
}

export const ReferralEvent = {
  SignUpEmailClick: 'sign_up_email_click',
  SignInEmailClick: 'sign_in_email_click',
  SignInSsoClick: 'sign_in_sso_click',
  EmailVerifiedInstallClick: 'email_verified_install_click',
} as const;

export type InstallButtonType = 'google' | 'apple' | 'lets_go';

export interface ReferralDataType {
  [ReferralEvent.SignUpEmailClick]: ReferralInfo;
  [ReferralEvent.SignInEmailClick]: ReferralInfo;
  [ReferralEvent.SignInSsoClick]: ReferralInfo & {
    auth_type: 'google' | 'apple';
  };
  [ReferralEvent.EmailVerifiedInstallClick]: {
    button_type: InstallButtonType;
    referral_code: string;
  };
}

export const TncTransitionEvent = {
  TncTransitionModalView: 'tnc_transition_modal',
  TncTransitionModalAcceptClick: 'tnc_transition_modal__click_accept',
} as const;

export type TncTransitionFromRoute = 'from_email' | 'organic_login' | 'identity_verification' | 'account';
export interface TncTransitionEventDataType {
  [TncTransitionEvent.TncTransitionModalView]: {
    from_route: TncTransitionFromRoute;
  };
}
